import axios from 'axios';

export const BASE_URL = process.env.NODE_ENV==="production"? `https://backend.${window.location.hostname}/`:"http://localhost:8000/"

const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export default axiosClient